module.exports = __webpack_public_path__ + "img/icon-duplication-all.2082cf06.svg";